export const setPattern = "editor/user-input/SET_PATTERN";
export const clearPattern = "editor/user-input/CLEAR_PATTERN";
